import React, { Component } from "react";

import Subheader from "material-ui/Subheader";
import Divider from "material-ui/Divider";
import Paper from "material-ui-next/Paper";
import { Tabs, Tab } from "material-ui/Tabs";

import GeneralInfo from "./general-info";
import FiscalInfo from "./fiscal-info";
import StockInfo from "./stock-info";
// import Sku from './sku';
import KitInfo from "./kit-info";
import Typography from "material-ui-next/Typography";

import { StyledButton, IconButton, Page, Loadable } from "components/support";

import { colors } from "assets";

import "./product-form.css";

class ProductForm extends Component {
  render() {
    const { presenter, viewModel } = this.props;
    const {
      title,
      loading,
      form,
      mode,
      defaultConfiguration,
      errors,
      optionalGroupsOpen,
      linkedOptionalGroups,
      optionalGroupsUuids,
      defaultTaxes,
      companyFiscalInformations,
      variationsList,
      fullVariationsListOptions,
      variationsListOptions,
      selectedVariations,
      /* skuLoading,
      hasSku,
      skuResultSet,
      skuResultSetErrors, */
      canEditStockCount
    } = viewModel;

    return (
      <Page>
        <Typography type="display1" className="pb-sm">
          <IconButton icon="arrow_back" onClick={() => presenter.onGoBack()} />
          {title}
        </Typography>
        <Loadable loading={loading}>
          <Paper elevation={1}>
            <Subheader>
              Os campos marcados com * são obrigatórios. <br />
            </Subheader>

            <Tabs
              inkBarStyle={{ backgroundColor: colors.accent.normal }}
              tabItemContainerStyle={{ backgroundColor: colors.primary.dark }}
              className="product-form-tabs"
            >
              <Tab label="Informações Gerais" className="tab-content">
                <GeneralInfo
                  product={form}
                  mode={mode}
                  errors={errors}
                  loading={loading}
                  linkedOptionalGroups={linkedOptionalGroups.slice()}
                  optionalGroupsOpen={optionalGroupsOpen}
                  optionalGroupsUuids={optionalGroupsUuids.slice()}
                  variationsList={variationsList.slice()}
                  fullVariationsListOptions={fullVariationsListOptions.slice()}
                  variationsListOptions={variationsListOptions.slice()}
                  selectedVariations={selectedVariations}
                  onOptionalGroupsOpen={async () =>
                    await presenter.onOptionalGroupsOpen(true)
                  }
                  onOptionalGroupsClose={async () =>
                    await presenter.onOptionalGroupsClose()
                  }
                  onOptionalGroupsSave={async updatedOptionalGroups =>
                    await presenter.onOptionalGroupsSave(updatedOptionalGroups)
                  }
                  loadProductVariations={async () =>
                    await presenter.loadProductVariations()
                  }
                  newVariationsOption={() => presenter.newVariationsOption()}
                  selectVariationsListOption={async (index, variationUuid) =>
                    await presenter.selectVariationsListOption(
                      index,
                      variationUuid
                    )
                  }
                  deleteVariationsOption={async (index, variation) =>
                    await presenter.deleteVariationsOption(index, variation)
                  }
                  editBarcode={(barcodeUuid, value) =>
                    presenter.editBarcode(barcodeUuid, value)
                  }
                  deleteIndexError={index => presenter.deleteIndexError(index)}
                />
              </Tab>
              {/*
                  mode==='edit' && hasSku ? 
                  <Tab label="SKUs" className="tab-content">
                    <Sku
                      product={form}
                      hasSku={hasSku}
                      skuLoading={skuLoading}
                      skuResultSet={skuResultSet}
                      skuResultSetErrors={skuResultSetErrors.slice()}
                      setLoading={(value) => presenter.setLoading(value)}
                      onChangeResultSetField={(index, field, value) => presenter.onChangeResultSetField(index, field, value)}
                      refreshResultSetBarcodes={async (barcodes, index) => await presenter.refreshResultSetBarcodes(barcodes, index)}
                    />
                  </Tab> : null
                  */}
              <Tab label="Informações Tributárias" className="tab-content">
                <FiscalInfo
                  product={form}
                  defaultTaxes={defaultTaxes}
                  companyFiscalInformations={companyFiscalInformations}
                  defaultConfiguration={defaultConfiguration}
                  onDefaultConfigurationChange={checked =>
                    presenter.onDefaultConfigurationChange(checked)
                  }
                  errors={errors}
                />
              </Tab>
              <Tab
                label="Informações de Estoque"
                className="tab-content"
                style={{
                  cursor:
                    form.type === "product_kit" ? "not-allowed" : "pointer"
                }}
                disabled={form.type === "product_kit"}
              >
                <StockInfo
                  product={form}
                  mode={mode}
                  errors={errors}
                  canEditStockCount={canEditStockCount}
                />
              </Tab>
              <Tab
                label="Kit/Combo"
                className="tab-content"
                style={{
                  cursor: form.type === "product" ? "not-allowed" : "pointer"
                }}
                disabled={form.type === "product"}
              >
                <KitInfo product={form} mode={mode} />
              </Tab>
            </Tabs>

            <Divider className="mt-sm" />

            <div className="text-right p-sm">
              <StyledButton
                label="Cancelar"
                onClick={() => presenter.onGoBack()}
                flat
              />

              <StyledButton
                label="Salvar Produto"
                primary={true}
                className="product__submit"
                onTouchTap={() => presenter.onSendForm()}
              >
                Salvar Produto
              </StyledButton>
            </div>
          </Paper>
        </Loadable>
      </Page>
    );
  }
}

export default ProductForm;



// WEBPACK FOOTER //
// ./src/components/app/registration/product/form/view.jsx